export function getUpcomingYears(upcomingYears = 10) {
  const years = []

  for (let i = 0; i < upcomingYears; i++) {
    years.push({
      value: new Date().getFullYear() + i,
      name: new Date().getFullYear() + i,
    })
  }

  return years
}
